autosize(document.querySelectorAll('textarea'));

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);

// We listen to the resize event
window.addEventListener('resize', () => {
  // We execute the same script as before
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});

document.arrive('.used-product-item', { existing: true }, function() {
  let productEnquire = document.querySelectorAll('.view-enquire')
  for (var i = 0; i < productEnquire.length; i++) {
    productEnquire[i].addEventListener('click', contactFill, false);
  }
});


function contactFill(e){
  let outerArticle = e.currentTarget.closest('article');
  let articleTitle = outerArticle.querySelector('.info-item[data-label="model"] .item-data').textContent;
  let articleRef = outerArticle.querySelector('.info-item[data-label="serialno"] .item-data').textContent;

  let messageContent;
  messageContent = `Hello, I would like to enquire about the following: ${articleTitle} -  Serial No: ${articleRef}`;
  let formSelector = document.querySelector('#section-contact-enquire');

  let messageTextarea = formSelector.querySelector('.message');
  messageTextarea.value = messageContent;
  autosize(messageTextarea);

  document.addEventListener('DOMContentLoaded', function() {
      setTimeout(function() {
          autosize.update(messageTextarea)
      }, 200);
   }, false);

   formSelector.scrollIntoView();
}

function checkStickyHeight(domNode){
    if(!domNode.classList.contains('is-sticky')){
        console.warn('No .is-sticky class on passed DOM Node.');
    }

    console.log('sdfsdf');
    const nodeHeight = domNode.offsetHeight;
    const windowHeight = window.innerHeight;
    const siteHeaderHeight = document.getElementById('masthead').offsetHeight;
    const availableHeight = windowHeight - siteHeaderHeight - 30;

    if(nodeHeight > availableHeight){
        domNode.classList.add('no-sticky');
        return true
    }else{
        domNode.classList.remove('no-sticky');
        return false
    }
}

const stickyElms = document.querySelectorAll(".is-sticky");       
stickyElms.forEach( function (stickyElm) {
    checkStickyHeight(stickyElm);
});

/**
 * filter Accordions
 */
const filters = document.querySelectorAll(".filter--js");
filters.forEach(function (filter) {
    new f11y.components.Accordion(
        filter,
        {
            onAfterClose: function() {
                const stickyElms = document.querySelectorAll(".is-sticky");
                
                stickyElms.forEach( function (stickyElm) {
                    checkStickyHeight(stickyElm);
                });
            },
            onAfterOpen: function() {
                const stickyElms = document.querySelectorAll(".is-sticky");
                stickyElms.forEach( function (stickyElm) {
                    checkStickyHeight(stickyElm);
                });
            },
            showMultiple: true,
        }
    );
});


const modals = document.querySelectorAll(".layer--js");

let isMastheadHidden;

modals.forEach(function (modalElm) {
    new f11y.components.Layer(
        modalElm,
        {
            onOpen: function(){
                const masthead = document.querySelector("#masthead");
                document.body.classList.add('has-layer-open');
        
                if(!masthead.classList.contains('hide')){
                    masthead.classList.add('hide');
                    isMastheadHidden = true
                }else{
                    isMastheadHidden = false
                }
            },
            onClose: function(){
                if(isMastheadHidden === true){
                    masthead.classList.remove('hide');
                }
                document.body.classList.remove('has-layer-open');
            },
        }
    );
});

document.arrive(
    ".layer--js", 
    function(newElm) {
        new f11y.components.Layer(
            newElm,
            {}
        );
    }
);